import { render } from "./index.vue?vue&type=template&id=68850fdd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=68850fdd&scoped=true&lang=css"

import exportComponent from "D:\\idea\\workplace\\parking\\duty-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68850fdd"]])

export default __exports__